import Vue from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import VueAxios from 'vue-axios';
import VueRecaptcha from 'vue-recaptcha';
import VueSweetalert2 from 'vue-sweetalert2';
import spinner from '../../components/frontend/Spinner';
import VueTheMask from 'vue-the-mask';

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueTheMask);

let app = new Vue({
    el: '#app-contacto',
    components: {
        VueRecaptcha,
        spinner
    },
    data: function () {
        return {
            contacto: {
                nombre_apellido: '',
                nacionalidad: 'V',
                cedula: '',
                telefono: '',
                correo: '',
                estado_id: '',
                asunto: '',
                mensaje: '',
                'g-recaptcha-response': ''
            },
            errores: [],
            mensaje_error: 'red',
            loading: false,
        }
    },
    methods: {
        captchaErrored() {
            this.contacto['g-recaptcha-response'] = '';
            this.$refs.recaptcha.reset();
        },
        captchaExpired() {
            this.contacto['g-recaptcha-response'] = '';
        },
        captchaVerify(res) {
            this.contacto['g-recaptcha-response'] = res;
            console.log(res);
        },
        guardar() {
            const url = "/api/contacto";

            this.loading = true;

            this.errores = [];

            this.$http({
                method: 'POST',
                url: url,
                data: this.contacto
            })
            .then((response) => {
                this.loading = false;
                this.contacto.nombre_apellido = '';
                this.contacto.nacionalidad = 'V';
                this.contacto.cedula = '';
                this.contacto.telefono = '';
                this.contacto.correo = '';
                this.contacto.asunto = '';
                this.contacto.mensaje = '';
                this.contacto.estado_id = '';
                this.contacto['g-recaptcha-response'] = '';
                this.mensaje("success", "Bien", response.data.success);

                window.gtag('event', 'generate_lead', {
                    event_category: 'formulario',
                    event_label: 'contacto',
                });
                window.fbq('track', 'Contact');

                if (this.$refs.recaptcha) {
                    this.$refs.recaptcha.reset();
                }
            }, (error) => {
                this.loading = false;
                this.errores = error.response.data.errors;
                this.mensaje("error", "Error", "Disculpe, verifique los datos ingresados.");

                this.contacto['g-recaptcha-response'] = '';

                if (this.$refs.recaptcha) {
                    this.$refs.recaptcha.reset();
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
        mensaje(tipo, titulo, mensaje) {
            this.$swal.fire({
                icon: tipo,
                title: titulo,
                text: mensaje,
                showCloseButton: true,
                showConfirmButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Aceptar',
            });
        }
    }
});
